<template>
  <div :id="localId" class="svg_wrapper"></div>
</template>

<script>
import mx_Core from './includes/mixins/zMixins'   
     
export default {
  name: "j-chart-project-1",
  mixins: [mx_Core],
  props: {
    id: String,
    modeExport: Boolean,
    getSelectItems: String,  

    FilterValues: { type: Object, default: () => ({}) },
    ColumnProps: { type: Array, default: () => ([]) },
    Canvas: { type: Object, default: () => ({}) },
    Text: { type: Object, default: () => ({}) },
    Note: { type: Object, default: () => ({}) },
    DataItems: { type: Array, default: () => ([]) },
    Queries: { type: Object, default: () => ({}) },
  },


  created() {
    this.localId = `${this.id || 'j-chart-custom'}__${this.safeId('')}`
    // console.log('this.id:', this.localId)
  },

  
  mounted() {
    this.register(this.draw)
  },

  methods: {
    
    draw() {
      if (!this.ready2draw) {
        return
      }

      this.clear()
      if (this.FilterValues.STAGE == 'PE1' || this.FilterValues.STAGE == 'BLK') this.Canvas.CanvasHeight = 350

      this.drawCanvas()
      this.drawing() // <------ Drawing Start
      
      this.drawNotes()
      this.drawTexts()
    },

    drawing() {

      this.set_LocalValues()
      this.set_Gradients()
      this.draw_Forms()

      // for Exporting PDF file
      this.getItems = this.getSelectItems ? JSON.parse(this.getSelectItems) : {}
      this.getItems.stage = null // 'Block'

      if(this.getItems.stage !== null) {
        this.draw_PDF(this.getItems.stage)
      }
      else {
        // this.draw_SvgFile()
      }
      
    },  

  }
}
</script>



<style lang="scss" scoped>
  .svg_wrapper {
    width: 810px;
    height: 1500px;

    overflow: hidden;
  }
</style>